var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccesssketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 165,
    viewBox: "0 0 167 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.0012 41.2241H84C62.1393 41.2241 44.4177 58.9457 44.4177 80.8064V80.8076C44.4177 102.668 62.1393 120.39 84 120.39H84.0012C105.862 120.39 123.584 102.668 123.584 80.8076V80.8064C123.584 58.9457 105.862 41.2241 84.0012 41.2241Z",
    fill: "url(#paint0_linear_286_7306)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6233 81.1467L78.0495 92.573L101.377 69.2432",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.186 126.39C127.574 127.175 130.595 129.086 132.755 131.812C134.417 134.746 135.438 138 135.751 141.358",
    stroke: "#49BDB6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.011 99.4041C35.5159 102.276 28.9855 107.431 22.8168 105.073C15.1066 102.127 15.3329 97.5891 17.8279 95.7753C20.323 93.9615 23.7208 96.9091 24.4044 99.4041C25.0879 101.899 23.9506 110.289 17.8279 113.464C11.7052 116.64 3.54129 115.052 1.5 113.464",
    stroke: "#EEABAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.318 19.1256C133.371 18.7473 127.202 20.4857 126.113 30.4647C125.024 40.4436 116.287 42.4837 112.053 42.2563",
    stroke: "url(#paint1_linear_286_7306)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1987 65.6783C28.2046 65.6783 30.6414 63.2415 30.6414 60.2356C30.6414 57.2297 28.2046 54.793 25.1987 54.793C22.1929 54.793 19.7561 57.2297 19.7561 60.2356C19.7561 63.2415 22.1929 65.6783 25.1987 65.6783Z",
    fill: "#F2D8AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1094 22.0737C60.6141 22.0737 62.6445 20.0433 62.6445 17.5386C62.6445 15.0339 60.6141 13.0034 58.1094 13.0034C55.6047 13.0034 53.5742 15.0339 53.5742 17.5386C53.5742 20.0433 55.6047 22.0737 58.1094 22.0737Z",
    fill: "#EEABAB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9418 28.8466C73.4363 28.8466 74.6478 27.6351 74.6478 26.1406C74.6478 24.6461 73.4363 23.4346 71.9418 23.4346C70.4474 23.4346 69.2358 24.6461 69.2358 26.1406C69.2358 27.6351 70.4474 28.8466 71.9418 28.8466Z",
    fill: "#EEABAB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.256 82.3775C146.948 82.3775 149.131 80.1945 149.131 77.5017C149.131 74.8089 146.948 72.626 144.256 72.626C141.563 72.626 139.38 74.8089 139.38 77.5017C139.38 80.1945 141.563 82.3775 144.256 82.3775Z",
    fill: "#EEABAB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8867 137.71C45.5795 137.71 47.7625 135.527 47.7625 132.834C47.7625 130.141 45.5795 127.958 42.8867 127.958C40.1939 127.958 38.011 130.141 38.011 132.834C38.011 135.527 40.1939 137.71 42.8867 137.71Z",
    fill: "#EEABAB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.662 151.998C106.355 151.998 108.538 149.815 108.538 147.122C108.538 144.429 106.355 142.246 103.662 142.246C100.969 142.246 98.7861 144.429 98.7861 147.122C98.7861 149.815 100.969 151.998 103.662 151.998Z",
    fill: "#EEABAB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5812 144.951C90.0757 144.951 91.2872 143.74 91.2872 142.245C91.2872 140.751 90.0757 139.539 88.5812 139.539C87.0868 139.539 85.8752 140.751 85.8752 142.245C85.8752 143.74 87.0868 144.951 88.5812 144.951Z",
    fill: "url(#paint2_linear_286_7306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_286_7306",
    x1: 76.457,
    y1: 81.1702,
    x2: 141.892,
    y2: 81.1702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40ADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#226A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_286_7306",
    x1: 121.874,
    y1: 30.7821,
    x2: 141.929,
    y2: 30.7821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40ADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#226A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_286_7306",
    x1: 88.0655,
    y1: 142.27,
    x2: 92.5388,
    y2: 142.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40ADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#226A86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesssketch);
export default __webpack_public_path__ + "static/media/successsketch.34e4f1b0051b1b9407183e5b12e9e262.svg";
export { ForwardRef as ReactComponent };